import {Component,} from '@angular/core';
import {OneToManyComponent} from "../../one-to-many.component";
import {MeteorologiaEspecime} from "../../../../domain/MeteorologiaEspecime";
import {Campanha} from "../../../../domain/Campanha";
import {TipoMeteorologia} from "../../../../domain/enums";
import {Utils} from "../../../../services/Utils";

@Component({
  selector: 'app-meteorologia',
  templateUrl: './edit-meteorologia.component.html',
  styleUrls: ['./edit-meteorologia.component.scss'],
})
export class EditMeteorologiaComponent extends OneToManyComponent<MeteorologiaEspecime> {
  tiposMeteorologias = Object.values(TipoMeteorologia)
  override newObject(): MeteorologiaEspecime {
    const resp = new MeteorologiaEspecime();
    resp.dataHora = Utils.dataHoraAtual()
    return resp
  }
}
